import { Injectable, inject } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { from } from 'rxjs'
import { map, switchMap, tap } from 'rxjs/operators'
import { ProductTypesService } from 'src/services/data/product-types.service'
import { ToasterService } from 'src/shared/toaster/toaster.service'
import { catchAndLog } from 'src/shared/utils/catch-and-log'
import { createProductType, createProductTypeFailure, createProductTypeSuccess, loadProductTypes, loadProductTypesFailure, loadProductTypesSuccess, updateProductType, updateProductTypeFailure, updateProductTypeSuccess } from './product-type.actions'

@Injectable()
export class ProductTypeEffects {
  private actions$ = inject(Actions)
  private ProductTypes = inject(ProductTypesService)
  private toaster = inject(ToasterService)


  loadProductTypes$ = createEffect(() => this.actions$.pipe(
    ofType(loadProductTypes),
    switchMap(() =>
      from(this.ProductTypes.getProductTypes()).pipe(
        map(productTypes => loadProductTypesSuccess({ productTypes })),
        catchAndLog(this.toaster, 'Unable to fetch productTypes', loadProductTypesFailure)))))

  createProductType$ = createEffect(() => this.actions$.pipe(
    ofType(createProductType),
    tap(() => this.toaster.progress('Creating product type...')),
    switchMap(action =>
      from(this.ProductTypes.create(action.productType)).pipe(
        map(productType => createProductTypeSuccess({ productType })),
        tap(() => this.toaster.success('Product type created successfully.')),
        catchAndLog(this.toaster, 'Unable to create product type', createProductTypeFailure)))))

  updateProductType$ = createEffect(() => this.actions$.pipe(
    ofType(updateProductType),
    tap(() => this.toaster.progress('Updating product type...')),
    switchMap(action =>
      from(this.ProductTypes.update({ ...action.productType, type_id: action.id })).pipe(
        map(productType => updateProductTypeSuccess({ productType })),
        tap(() => this.toaster.success('Product type updated successfully.')),
        catchAndLog(this.toaster, 'Unable to update product type', updateProductTypeFailure)))))
}
